import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Intro from "@/components/Intro";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [introDone, setIntroDone] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => setIntroDone(true), 2300);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (introDone && location.state?.scrollTo) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 120);
      window.history.replaceState(null, "");
      return () => clearTimeout(t);
    }
  }, [introDone, location.state]);

  return (
    <div data-testid="home-page" className="relative min-h-screen bg-[#0B0C0E] text-[#EAE6E1]">
      <div className="noise-overlay" aria-hidden="true" />
      <AnimatePresence>{!introDone && <Intro />}</AnimatePresence>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Portfolio />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
